import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BootSplash } from "./components/BootSplash";
import { PasswordGate } from "./components/PasswordGate";
import { ScrollToTop } from "./components/ScrollToTop";
import { HomePage } from "./pages/HomePage";
import { VideosPage } from "./pages/VideosPage";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8nedijx7b8k">
      <PasswordGate data-id="element-1" data-mp="2rknm2e6yncrv">
        <ScrollToTop data-id="element-2" data-mp="2rlyreig20sl3" />
        <BootSplash data-id="element-3" data-mp="2rlf6qtz0rq3d" />
        <a href="#top" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[140] focus:inline-flex focus:min-h-11 focus:items-center focus:bg-[#54f6c6] focus:px-4 focus:font-mono focus:text-[10px] focus:uppercase focus:tracking-[0.16em] focus:text-[#05100d]" data-id="element-4" data-mp="2rit3h6j5vwqy">
          Skip to content
        </a>
        <Routes data-id="element-5" data-mp="28te2fc3h77mk">
          <Route path="/" element={<HomePage data-id="element-7" data-mp="28sbe9bxjfjac" />} data-id="element-6" data-mp="28suw6sn6u7od" />
          <Route path="/videos" element={<VideosPage data-id="element-9" data-mp="23u9vyt7xrnzx" />} data-id="element-8" data-mp="23vkuadim43jn" />
        </Routes>
      </PasswordGate>
    </BrowserRouter>;
}